export default "__VITE_ASSET__e631b028__"